import { ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSelect } from '@angular/material/select';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { Filter } from 'src/app/interfaces/filter';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { FilterviewComponent } from '../gridview/filterview/filterview.component';
import { SalvarfiltroComponent } from '../gridview/salvarfiltro/salvarfiltro.component';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'app-simple-filter-view',
    templateUrl: './simple-filter-view.component.html',
    styleUrls: ['./simple-filter-view.component.scss'],
    standalone: false
})
export class SimpleFilterViewComponent implements OnInit {

  showFilter = false;
  filters:Filter[];
  @ViewChild("expansion") expansion: MatExpansionPanel;
  @ViewChild("selectFilter") selectFilter:MatSelect;
  @ViewChild(FilterviewComponent) filter: FilterviewComponent;
  selectedValue: string;
  dataRowColumns:columnsDef[] = [];
  editing:Filter = null;
  

  constructor(@Inject(MAT_DIALOG_DATA) public data,public ThemeService:ThemeService, public dialogRef:MatDialogRef<any>,private cd:ChangeDetectorRef,private snackBar:SnackbarService, private dialogServices:DialogService) { 
      this.filters = this.data.filters;
      this.editing = this.data.editing;
      this.dataRowColumns = this.data.columns;
   
  }

  ngOnInit(): void {
    
    if ( this.editing != null){
      this.showFilter = true;   
    }
  }


  open(){
   
  }

  close(){
   
  }

  ngAfterViewInit(){
    

  } 

  salvar(event:Event){
    event.stopPropagation();
    event.preventDefault();
    
    if ( this.filter.fields.length == 0){
      this.snackBar.showError("Não existe nenhuma expressão informado no filtro.");
      return;
    }

    if ( this.editing != null ){
      
      this.saveFunction(this.editing);
      this.cd.detectChanges();
    }else{
      this.dialogServices.openGenericDialog(SalvarfiltroComponent,{name:''},(data)=>{
        
        if ( this.filters.findIndex(c=>c.name == data['name']) > -1 ){
          this.snackBar.showError("Já existe um filtro com esse nome.");
          return;
        }
        this.saveFunction(data);
        this.cd.detectChanges();
    })
    }
    
      
    

 }

 saveFunction(data){
  
  let expression:string[] = this.filter.fields;
  this.filter.filterForm.get('expressaoCtrl').setValue(null);
  this.filter.fields = [];
  

  let expressao = ObjectUtil.arrayStringToString(expression);
  let name = data.name;

  let filter:Filter = {name:name, expression:expressao, lastfilter:'' };
  
  if ( this.filters == null || this.filters == undefined ){
      this.filters = [];
  }
  
  if ( this.editing ){
    let index = this.filters.findIndex(c=>c.name == name);
    this.filters[index] = filter;
    this.editing = null;

  }else{
    this.filters.push(filter);
  }



  this.dialogRef.close(true);

}

cancelar(event:Event){
  event.stopPropagation();
  event.preventDefault();
  this.editing = null;
  this.showFilter=false
  this.filter.clearAll();
}

editar(data){
  data.stopPropagation();
  data.preventDefault();

  if ( (this.selectFilter.selected as MatOption[]).length != 1 ){
    this.snackBar.showError("Para editar um filtro deve-se escolher apenas 1 registro.");
    return;
  }
  this.filter.clearAll();
  (this.selectFilter.selected as MatOption[]).forEach(value=>{
    
      this.editing = this.filters.find(filter=>filter.name == value.value.name);
      
      this.showFilter = true;
  });
}

excluir(data){

    data.stopPropagation();
    data.preventDefault();
      
    (this.selectFilter.selected as MatOption[]).forEach(value=>{
      let index = this.filters.findIndex(filter=>filter.name == value.value.name);
      this.filters.splice(index,1);
    });

  }

  novo(event:Event){
    event.stopPropagation();
    event.preventDefault();
    this.editing = null;
    this.filter.clearAll();
    this.showFilter = true;
  }



}
